<template>
<div class="chapter">
<div class="inner_page">
<p class="break"> </p>
<p class="toc">CONTENTS</p>
<p class="bigspace">
</p><p class="tocitem"><a href="#/html/06_chap1#c1" id="toc1">The First Word: <i>The Value of Ignorance</i></a></p>
<p class="tocitem"><span href="#/html/07_chap2#c2" id="toc2" title="Link target outside of Sample">The Second Word: <i>The Secret of Sanctity</i></span></p>
<p class="tocitem"><span href="#/html/08_chap3#c3" id="toc3" title="Link target outside of Sample">The Third Word: <i>The Fellowship of Religion</i></span></p>
<p class="tocitem"><span href="#/html/09_chap4#c4" id="toc4" title="Link target outside of Sample">The Fourth Word: <i>Confidence in Victory</i></span></p>
<p class="tocitem"><span href="#/html/10_chap5#c5" id="toc5" title="Link target outside of Sample">The Fifth Word: <i>Religion is a Quest</i></span></p>
<p class="tocitem"><span href="#/html/11_chap6#c6" id="toc6" title="Link target outside of Sample">The Sixth Word: <i>The Hour</i></span></p>
<p class="tocitem"><span href="#/html/12_chap7#c7" id="toc7" title="Link target outside of Sample">The Seventh Word: <i>The Purpose of Life</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_contents.vue?70d77a9d